







































































































































































































import axios from 'axios';
import Vue from 'vue';
import i18n from 'vue-i18n';
import { get, sortBy, groupBy, forEach } from 'lodash';
import EventBus from '@/eventBus';
import Features from '@/components/Templates/Admin/Settings/Features/Features.vue';
import CoLegalLinks from '@/components/Molecules/co-legal-links/CoLegalLinks.vue';
import CoMenuItem from '../../Molecules/co-menu-item/CoMenuItem.vue';
import CoThumbnail from '../../Molecules/co-thumbnail/CoThumbnail.vue';
import CoButton from '../../Atoms/co-button/CoButton.vue';
import CoText from '../../Atoms/co-text/CoText.vue';
import CoHeadline from '../../Atoms/co-headline/CoHeadline.vue';
import CoSkeleton from '../../Atoms/co-skeleton/CoSkeleton.vue';
import CoModal from '../co-modal/CoModal.vue';
import CoCoappBadge from '../co-coapp-badge/CoCoappBadge.vue';

Vue.use(i18n);

export default {
    name: 'CoLeftMainNavigation',
    components: {
        CoMenuItem,
        CoThumbnail,
        CoButton,
        CoText,
        CoHeadline,
        CoSkeleton,
        CoModal,
        CoCoappBadge,
        CoLegalLinks,
        Features,
    },
    props: {
        spaceName: {
            type: String,
            default: null,
        },
        logoURL: {
            type: String,
            default: null,
        },
        spaceID: {
            type: String,
            default: null,
        },
        isAdmin: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        circlesOn: {
            type: Boolean,
            default: false,
        },
        welcomeChecklist: {
            type: Boolean,
            default: false,
        },
        communityPlan: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            thisSpaceID: get(this.$store, 'state.space.ID', null) || this.spaceID,
            menuLoading: false,
            channels: [],
            customMenuItems: [],
            channelName: null,
        };
    },
    computed: {
        // Permissions can arrive after navigation mounts in a newly created community.
        localAdmin() {
            const permissions = this.$store?.state?.me?.Permissions;
            return permissions ? permissions.includes('space_admin') : this.isAdmin;
        },
        // Keep feature navigation in sync with changes saved in the feature modal.
        isBookingOn() {
            return !!this.$store?.state?.space?.BookingOn;
        },
        isMarketOn() {
            return !!this.$store?.state?.space?.MarkeplaceOn;
        },
        // Hide member-facing event navigation when the space disables events globally.
        isEventsEnabled() {
            if (this.$store && this.$store.state && this.$store.state.space) {
                return !this.$store.state.space.EventsOff;
            }
            return true;
        },
        // Channels are page containers, so hide them with the pages feature.
        isPagesEnabled() {
            return !this.$store?.state?.space?.PagesOff;
        },
        maxChannelsReached() {
            const maxChannels = this.$store.state.limits.MaxChannels || 100; // default to 100 if not set

            if (this.channels && this.channels.length >= maxChannels) {
                return true;
            }

            return false;
        },
        feedLabel() {
            return this.$store?.state?.customMenuLabelOverrides?.feed || this.$t('labels.feed');
        },
        communityLabel() {
            return this.$store?.state?.customMenuLabelOverrides?.community || this.$t('labels.community');
        },
    },
    watch: {
        // Channels are not requested while Pages is disabled, so fetch them when an admin enables it.
        isPagesEnabled(isEnabled, wasEnabled) {
            if (isEnabled && !wasEnabled) this.listChannels();
        },
    },
    async mounted() {
        this.menuLoading = true;
        await this.getMenuContent();
        this.menuLoading = false;
    },
    methods: {
        getMenuContent() {
            return Promise.all([
                this.isPagesEnabled ? this.listChannels() : Promise.resolve(),
                this.getCustomMenuItems(),
            ]);
        },
        listChannels() {
            const circlesOn = get(this.$store, 'state.circlesOn', this.circlesOn);
            if (circlesOn) {
                return this.listForCircles();
            }
            return new Promise((resolve, reject) => {
                axios
                    .get('/project/channel/list')
                    .then((response) => {
                        const channels = get(response, 'data.objects', []);
                        // map channels to menu items by adding URL and name
                        this.channels = channels.map((channel) => ({
                            id: channel.object.ID,
                            url: `/channels/${channel.object.Slug}`,
                            name: get(channel, 'object.Value', null),
                            space: get(channel, 'space', {}),
                        }));

                        // sort channels alphabetically by name using lodash
                        this.channels = sortBy(this.channels, [(channel) => channel.name.toLowerCase()], ['desc']);
                        resolve(true);
                    })
                    .catch((error) => {
                        resolve(true);
                    });
            });
        },
        listForCircles() {
            return new Promise((resolve, reject) => {
                const circlesOn = get(this.$store, 'state.circlesOn', false);
                axios
                    .post('/channel/list/circles')
                    .then((response) => {
                        const channels = get(response, 'data.Objects', []);
                        // map channels to menu items by adding URL and name
                        this.channels = channels.map((channel) => ({
                            id: channel.object.ID,
                            url: `/channels/${channel.object.Slug}?id=${channel.object.ID}`,
                            name: get(channel, 'object.Value', null),
                            space: get(channel, 'space', {}),
                        }));
                        // sort channels alphabetically by spacename
                        this.channels = sortBy(this.channels, [(channel) => channel.name.toLowerCase()], ['desc']);
                        // group channels by spaceid
                        const groups = groupBy(this.channels, (channel) => channel.space.ID);
                        // reset channels and collect and sort the circle channels alphabetically
                        this.channels = [];
                        forEach(groups, (value, key) => {
                            if (key !== this.thisSpaceID) {
                                this.channels = this.channels.concat(value);
                            }
                        });
                        this.channels = sortBy(this.channels, [(channel) => channel.name.toLowerCase()], ['desc']);
                        // prepend the local channels to the beginning of the array
                        this.channels = groups[this.thisSpaceID].concat(this.channels);

                        resolve(true);
                    })
                    .catch((error) => {
                        resolve(true);
                    });
            });
        },
        getCustomMenuItems() {
            return new Promise((resolve, reject) => {
                axios
                    .get('/dashboard/custom-menu-options/list')
                    .then((response) => {
                        this.customMenuItems = get(response, 'data', []).filter(
                            (item) => (!item.Type || item.Type === 0) && !item.Hidden
                        );
                        if (!this.customMenuItems) {
                            this.customMenuItems = [];
                        }
                        resolve(true);
                    })
                    .catch((error) => {
                        this.customMenuItems = [];
                        resolve(true);
                    });
            });
        },
        startChannelCreation() {
            if (!this.isPagesEnabled) return;
            if (this.maxChannelsReached) {
                this.triggerPaywall('more-channels');
                return;
            }
            this.channelName = '';
            this.$refs['modal-create-project-type'].show();
        },
        triggerPaywall(feature: string) {
            EventBus.$emit('PAYWALL', {
                feature,
            });
        },

        createChannel() {
            const data = JSON.stringify({ Value: this.channelName });

            axios({
                method: 'POST',
                url: '/admin/community/project-type',
                data,
                withCredentials: true,
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(() => {
                    this.channelName = '';
                    this.listChannels();
                    this.$nextTick(() => {
                        this.$refs['modal-create-project-type'].hide();
                    });
                })
                .catch((error) => {
                    console.log(error);
                });
        },
    },
};
